export const decimalFormatLocale = (number, decimalPlaces = 2) => {
  const parseNumber = parseFloat(number);
  return parseNumber.toLocaleString('id-ID', {
    style: 'decimal',
    maximumFractionDigits: decimalPlaces,
  });
};
